<template>
  <div id="sparks" class="page-container">
    <div class="page-content">
      <div class="flex-row-center mt-16">
        <img src="../assets/images/navbar/ic_sparks.webp" class="icon-pages" />
        <span class="page-title">{{ $t('page.sparks') }}</span>
        <span class="page-des page-des-line">{{ $t('page.sparks_description') }}</span>
      </div>

      <el-tabs class="style-bar" v-model="activeName">
        <el-tab-pane name="nudges">
          <span slot="label" class="title-bar">Nudges</span>
          <nudges></nudges>
        </el-tab-pane>
        <el-tab-pane name="micro-learning">
          <span slot="label" class="title-bar">{{ $t('page.micro_learning') }}</span>
          <micro-learning></micro-learning>
        </el-tab-pane>
        <!-- <el-tab-pane name="coaching">
          <span slot="label" class="title-bar">Coaching</span>
          <coaching></coaching>
        </el-tab-pane> -->
      </el-tabs>
    </div>
  </div>
</template>

<script>
export default {
  name: "Sparks",
  components: {
    microLearning: require("./sparks/micro-learning").default,
    // coaching: require("./sparks/coaching").default,
    nudges: require("./sparks/nudges").default,
  },
  watch: {
    activeName() {
      if (this.activeName != "") {
        const tab = this.activeName || "";
        const paramsTab = this.$router.currentRoute.params.tab;
        if (paramsTab != tab) {
          this.$router.push({ name: "sparks", params: { tab } });
        }
      }
    },
  },
  data() {
    return {
      activeName: "micro-learning",
      anchor: {
        nudges: "nudges",
        microLearning: "micro-learning",
        // coaching: "coaching",
      },
      renderComponent: true
    };
  },
  mounted() {
    const params = this.$router.currentRoute.params.tab;
    if (params && this.anchor[params]) {
      this.activeName = params;
    } else {
      this.$router.push({ name: 'sparks', params: { tab: "nudges" } })
    }
    this.$root.$on('changeTab', (item) => {
      if (item.path == "sparks") {
        this.onChangedTab(item);
      }
    });
  },
  methods: {
    getImgUrl(pic) {
      var images = require.context(
        "../assets/images/spotlight/",
        false,
        /\.png$/
      );
      return images("./" + pic + ".png");
    },
    nextMember() {
      this.$store.dispatch("people/nextMember");
    },
    onChangedTab(value) {
      this.activeName = value.tab;
    }
  },
};
</script>

<style scoped>
.tabsTitle {
  height: 52px;
  width: 150px;
  line-height: 52px;
  font-size: 16px;
  font-weight: 400;
  color: #000;
}
</style>
<style lang="scss">
#sparks .el-tabs__item {
  height: 52px;
  line-height: 52px;
  text-align: center;
  width: 150px;
  color: #000000;
  &:nth-child(2) {
    width: 170px;
    padding: 0;
  }
}
#sparks .el-tabs__header {
  margin: 0px;
}
</style>